
/**
 * Mesmos valores da enum do backend.
 */
export enum AnuncioInteresseSituacaomEnum {

  APROVADO = 1, NAO_ATENDIDO = 2, PENDENTE = 3, ENTREGUE = 4, CANCELADO = 5
}
